export const button = {
  textAlign: 'right',
}

export const name = {
  width: '100%',
}

export const innerFormGroup = {
  marginLeft: 0,
}
